import { useQuery } from '@tanstack/react-query';
import { endpoints, getIDFromUrl, Url } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';

export const QUERY_KEY_SPLIT_SUGGESTED_EDIT = 'document-split-suggested-edit';

/**
 * `annotation.suggestedEdit` is a URL, not an embedded object, and there is no
 * sideload for it — so the suggested edit is its own read.
 */
export const useSuggestedEdit = (suggestedEditUrl: Url | null | undefined) =>
  useQuery({
    queryKey: [QUERY_KEY_SPLIT_SUGGESTED_EDIT, suggestedEditUrl] as const,
    queryFn: () => {
      if (!suggestedEditUrl) {
        throw new Error('Missing suggested edit URL.');
      }

      return api.request(
        endpoints.suggestedEdit.get(getIDFromUrl(suggestedEditUrl))
      );
    },
    enabled: !!suggestedEditUrl,
  });
